import { pushToDataLayer } from "@common/utils/dataLayer";

/** GA4/GTM event names for VOIP funnel tracking */
export const VOIP_EVENTS = {
    WIDGET_OPENED: "voip_widget_opened",
    CALLER_ID_SUBMITTED: "voip_caller_id_submitted",
    CALLER_ID_VERIFIED: "voip_caller_id_verified",
    DESTINATION_ADDED: "voip_destination_added",
    OUTBOUND_CALL_INITIATED: "voip_outbound_call_initiated",
} as const;

export type VoipSource = "patient_header" | "call_settings" | "calendar" | "list_view" | "quick_start";

/** Push VOIP events to dataLayer for GTM/GA4. Use consistent event names and properties for funnel analysis. */
export const voipAnalytics = {
    widgetOpened: (params: { source: VoipSource }) => {
        pushToDataLayer({
            event: VOIP_EVENTS.WIDGET_OPENED,
            voip_source: params.source,
        });
    },

    callerIdSubmitted: (params: { verification_status: "success" | "pending"; source?: VoipSource }) => {
        pushToDataLayer({
            event: VOIP_EVENTS.CALLER_ID_SUBMITTED,
            voip_verification_status: params.verification_status,
            ...(params.source && { voip_source: params.source }),
        });
    },

    callerIdVerified: (params?: { source?: VoipSource }) => {
        pushToDataLayer({
            event: VOIP_EVENTS.CALLER_ID_VERIFIED,
            ...(params?.source && { voip_source: params.source }),
        });
    },

    destinationAdded: (params?: { source?: VoipSource }) => {
        pushToDataLayer({
            event: VOIP_EVENTS.DESTINATION_ADDED,
            ...(params?.source && { voip_source: params.source }),
        });
    },

    outboundCallInitiated: (params: { patient_record_id?: string }) => {
        pushToDataLayer({
            event: VOIP_EVENTS.OUTBOUND_CALL_INITIATED,
            ...(params.patient_record_id && { voip_patient_record_id: params.patient_record_id }),
        });
    },
};
